<template>
  <swiper dir="rtl" :slidesPerView="'auto'" :navigation="getNavigation(option)" :freeMode="true"
          :spaceBetween="15" @swiper="onSwiper">
    <swiper-slide v-for="(val, index) in option.values" :virtualIndex="index">
      <div :class="getValueClass(option, val)" @click="onValueClick(option, val)" :data-tippy-content="val.name">
        <img :src="val.image" loading="lazy" width="28" height="28" :alt="val.name">
      </div>
    </swiper-slide>
  </swiper>
  <div class="product__option__navs" :style="{visibility: isShowArrows ? 'visible' : 'hidden'}">
    <div class="product__option__navs__prev">
      <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.871167 20C0.631052 20.0004 0.436057 19.8061 0.435609 19.566C0.435405 19.4502 0.481382 19.3392 0.56335 19.2574L9.82135 10.0002L0.56335 0.743142C0.393341 0.573133 0.393341 0.297516 0.56335 0.127507C0.733358 -0.0425022 1.00898 -0.0425022 1.17898 0.127507L10.744 9.69247C10.9137 9.86224 10.9137 10.1374 10.744 10.3073L1.17898 19.8722C1.09742 19.954 0.98668 20 0.871167 20Z"
          fill="#E5E5E5"/>
      </svg>
    </div>
    <div class="product__option__navs__next">
      <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.0001 1.86927e-06C10.2402 -0.000446337 10.4352 0.193895 10.4356 0.434011C10.4358 0.549768 10.3898 0.660839 10.3079 0.742603L1.04986 9.99975L10.3079 19.2569C10.4779 19.4269 10.4779 19.7025 10.3079 19.8725C10.1379 20.0425 9.86224 20.0425 9.69223 19.8725L0.127265 10.3075C-0.0424586 10.1378 -0.0424586 9.86255 0.127265 9.69275L9.69223 0.127823C9.77379 0.0460185 9.88454 1.85917e-06 10.0001 1.86927e-06Z"
          fill="#019CDE"/>
      </svg>
    </div>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/swiper.scss';
import SwiperCore, {
  Navigation,
  Virtual
} from 'swiper/core';
import {ref} from "vue";

// install Swiper modules
SwiperCore.use([Navigation, Virtual]);

export default {
  name: "OptionColor",
  props: {
    option: {},
    selected: {},
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup(props, {emit}) {
    const getNavigation = (option) => {
      return {
        nextEl: `.product__option[data-id="${option.id}"] .product__option__navs__next`,
        prevEl: `.product__option[data-id="${option.id}"] .product__option__navs__prev`,
      }
    }

    const getValueClass = (option, val) => {
      return {
        'product__option__value': true,
        'active': props.selected[option.id] === val.id,
      }
    }

    const onValueClick = (option, val) => {
      emit('click', {option, val})
    }

    const isShowArrows = ref(true)

    const onSwiper = (swiper) => {
      if(swiper.virtualSize === swiper.width){
        isShowArrows.value = false
      }
    }

    return {
      isShowArrows,
      getNavigation,
      getValueClass,
      onValueClick,
      onSwiper
    }
  }
}
</script>

<style scoped>
.swiper-container {
  width: 100%;
}
</style>
